/**
 * @file platform.js
 * @description Rutas del tablero de Plataforma (visible solo para
 *              `platform-admin` — el guard de UI está en `SidebarNav.vue`
 *              vía el getter `isPlatformAdmin`; el backend también rechaza con
 *              403 si llega un user no-platform).
 */

const platformRoutes = [
  {
    path: "/platform/tenants",
    name: "platform-tenants",
    component: () =>
      import(
        /* webpackChunkName: "platform" */ "../components/platform/TenantList.vue"
      ),
  },
  {
    path: "/platform/tenants/:id",
    name: "platform-tenant-detail",
    component: () =>
      import(
        /* webpackChunkName: "platform" */ "../components/platform/TenantDetail.vue"
      ),
  },
];

export default platformRoutes;
